import { REDUX_STORE } from '@funnels/constants';
import {
  ClearApplicationErrorAction,
  CreateApplicationAction,
  CreateApplicationFailAction,
  CreateApplicationSuccessAction,
  FetchApplicationsAction,
  FetchApplicationsFailAction,
  FetchApplicationsSuccessAction,
  ServerApplicationFetch,
  SetApplicationErrorAction,
  SetApplicationLockedAction,
  StoreApplication,
  UpdateApplicationAbortAction,
  UpdateApplicationAction,
  UpdateApplicationFailAction,
  UpdateApplicationSuccessAction,
} from '@funnels/types';

export function clearApplicationError(): ClearApplicationErrorAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.CLEAR_APPLICATION_ERROR };
}

export function createApplication(application: StoreApplication): CreateApplicationAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.CREATE_APPLICATION, application };
}

export function createApplicationFail(clientId: string): CreateApplicationFailAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.CREATE_APPLICATION_FAIL, clientId };
}

export function createApplicationSuccess(clientId: string, id: string): CreateApplicationSuccessAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.CREATE_APPLICATION_SUCCESS, clientId, id };
}

export function fetchApplications(applicationId?: string, customerId?: string): FetchApplicationsAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.FETCH_APPLICATIONS, applicationId, customerId };
}

export function fetchApplicationsFail(): FetchApplicationsFailAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.FETCH_APPLICATIONS_FAIL };
}

export function fetchApplicationsSuccess(applications: ServerApplicationFetch[]): FetchApplicationsSuccessAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.FETCH_APPLICATIONS_SUCCESS, applications };
}

export function setApplicationError(message: string = 'Unknown error'): SetApplicationErrorAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.SET_APPLICATION_ERROR, message };
}

export function updateApplication(application: StoreApplication): UpdateApplicationAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.UPDATE_APPLICATION, application };
}

export function updateApplicationFail(clientId: string): UpdateApplicationFailAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.UPDATE_APPLICATION_FAIL, clientId };
}

export function updateApplicationAbort(): UpdateApplicationAbortAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.UPDATE_APPLICATION_ABORT };
}

export function updateApplicationSuccess(): UpdateApplicationSuccessAction {
  return { type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.UPDATE_APPLICATION_SUCCESS };
}

export function setApplicationLocked(payload: boolean): SetApplicationLockedAction {
  return {
    type: REDUX_STORE.APPLICATIONS.ACTION_TYPES.SET_APPLICATION_LOCKED,
    payload,
  };
}
